import { render } from "./MacchinaDettaglio.vue?vue&type=template&id=331e34a2"
import script from "./MacchinaDettaglio.vue?vue&type=script&lang=js"
export * from "./MacchinaDettaglio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__